/**
 * UI-internal DOM events, for the few cases where one component's state change has to reach
 * another component that it doesn't own and isn't owned by. Deliberately tiny — anything with a
 * real data payload should go through an explicit callback in main.ts instead.
 */

/** Fired on `document` when the E3 task templates are added/edited/removed in the pipeline panel. */
export const TEMPLATES_CHANGED_EVENT = 'naulon:templates-changed';
